import { styled, useTheme } from "@mui/system";
import { Typography } from "@mui/material";
import { TagSection } from "components/Shared/Dashboard/styled";

export const MainCardContainer = styled("div")(({ theme }) => ({
  width: "100%",
  backgroundColor: "white",
  borderRadius: theme.shape.borderRadius,
  height: "496px",
  display: "flex",
  flexDirection: "column",
}));

export const TitleSection = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  minHeight: "56px",
  borderBottom: `solid 3px ${theme.palette.disabled.light}`,
  alignItems: "center",
  padding: "0 24px 0 24px",
}));

export const TagComponent = ({ title }: { title: string | number }) => {
  const theme = useTheme();
  return (
    <TagSection>
      <Typography textAlign="center" color={theme.palette.primary.main}>
        {title}
      </Typography>
    </TagSection>
  );
};
